import React from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { FormField, HeaderOptions } from '../../types/form';

interface HeaderFieldEditorProps {
  editedField: FormField;
  onFieldChange: (updates: Partial<FormField>) => void;
}

export const HeaderFieldEditor: React.FC<HeaderFieldEditorProps> = ({
  editedField,
  onFieldChange,
}) => {
  const options = (editedField.options || {}) as HeaderOptions;

  return (
    <div>
      <Label htmlFor={`fontSize-${editedField.id}`}>Font Size</Label>
      <Select
        value={options.fontSize || 'medium'}
        onValueChange={(value) => onFieldChange({ 
          options: { ...editedField.options, fontSize: value }
        })}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select font size" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="small">Small</SelectItem>
          <SelectItem value="medium">Medium</SelectItem>
          <SelectItem value="large">Large</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
